export default __webpack_public_path__ + "static/media/logo.991f8fce.png";